import axiosInstance from "./Utils/axiosInstance";
import { APP_CODE } from "../Constants"
export class AuthApi {
  static async getAppsNavigation(empId) {
    try {
      const { data } = await axiosInstance.post(
        "/TIP/rest/Homepageservice/1.0/getAppsNavigationData",
        {
          empId
        }
      );
      if (data.AppsNavigationData && data.AppsNavigationData[0]) {
        axiosInstance.defaults.headers["sessionId"] =
          data.AppsNavigationData[0].sessionId;
        axiosInstance.defaults.headers["ssoId"] = empId;
        return data.AppsNavigationData[0];
      } else {
        throw data;
      }
    } catch (error) {
      throw error;
    }
  }

  static async logout(payload){
    try {
      return axiosInstance.post(
        "/service/workorder-crud-service/2.0/techClock",
        payload
      ).then(res => new Promise(resolve => {
        setTimeout(() => {
            resolve(res.data);
          }, 1000);
        })
      ).catch(function (error) {
        throw error;
      });
    }catch (error) {
      throw error;
    }
  }

  static async getUserInfo(auth) {
    try {
      const { data } = await axiosInstance.post(
        "/TIP/rest/Homepageservice/1.0/fetchDefaultProfileSettings",
        {
          appCd: APP_CODE,
          ssoId: auth.ssoId
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async saveProfileData(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/TIP/rest/Homepageservice/1.0/updateProfile",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
}
